import { combineReducers } from 'redux';
import authReducer from './authReducer';
import userReducer from './userReducer';
import errorReducer from './errorReducer';
import qsServerReducer from './qsServerReducer';
import pagesReducer from './pagesReducer';
import groupsReducer from './groupsReducer';
import objectsReducer from './objectsReducer';
import qlikReducer from './qlikReducer';
import layoutReducer from './layoutReducer';
import siteSettingsReducer from './siteSettingsReducer';
import themeReducer from './themeReducer';
import dagReducer from './dagReducer';
import usersReducer from './usersReducer';
import dataTablesReducer from './dataTablesReducer';
import fileUploadReducer from './fileUploadReducer';
import alerts from 'redux/alerts';
import active from 'redux/active';

export default combineReducers({
    auth: authReducer,
    user: userReducer,
    errors: errorReducer,
    qsServer: qsServerReducer,
    pages: pagesReducer,
    groups: groupsReducer,
    objects: objectsReducer,
    qlik: qlikReducer,
    layout: layoutReducer,
    settings: siteSettingsReducer,
    theme: themeReducer,
    dag: dagReducer,
    users: usersReducer,
    dataTables: dataTablesReducer,
    upload: fileUploadReducer,
    alerts,
    active,
});
